<template>
    <v-group :config="groupConfig">
        <template v-for="l in layer.layers">
            <mockup-image 
                :key="l.id" 
                v-if="l.type==='Image'"
                :layer="l"
            />
            <mockup-group v-if="l.type === 'Group'" :layer="l" :key="l.id" />
            <print-area-bundled v-if="l.type === 'Printarea'" :layer="l" :key="l.id" />
        </template>
    </v-group>
</template>

<script>
import MockupImage from './MockupImage';
import PrintAreaBundled from './PrintAreaBundled';

export default {
  components: { MockupImage, PrintAreaBundled },
    name: "mockup-group",
    props: {
        layer: {
            type: Object,
            required: true
        },
        mockupID: {
            type: String,
            required: true
        }
    },
    computed: {
        groupConfig() {
            return this.layer
        }
    }
}
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/BundledProduct/MockupBundled/MockupGroup.vue